import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment'
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CacheService, IUserCategoryBO } from '@mapfre-tech/amap3';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CategoriesService {

  className = 'CategoriesService';

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  // user-categories para peticion de post - editar // put - añadir // delete - eliminar // get - obtener
  getAll(userAmapId: number, cache = true, cacheKey = "userCategories"): Observable<IUserCategoryBO[]> { 
    let end: string;
    end = "?userAmapId=" + userAmapId.toString()
    
    if (cache && this.cacheService.canUseCache(cacheKey, [userAmapId.toString()])) {
      return this.cacheService.getCacheData(cacheKey, [userAmapId.toString()]) as object as Observable<IUserCategoryBO[]>;
    } else {
      const observable = this.http.get<IUserCategoryBO[]>(environment.base_URL + `/user-categories`+ end).pipe(
         map(res => {
            this.cacheService.updateCacheData(res, cacheKey, [userAmapId.toString()]);
            return res;
         })
      );
      this.cacheService.updateCacheReq(cacheKey, [userAmapId.toString()]);
      return observable;
   }
  }

  newCategory(category: IUserCategoryBO) { 
    return this.http.post(environment.base_URL + `/user-categories`, category)
  }

  updateCategory(categoryId: number, category: IUserCategoryBO) {
    return this.http.put(environment.base_URL + `/user-categories/${categoryId}`, category)
  }

  deleteCategory(categoryId: number) {
    return this.http.delete(environment.base_URL + `/user-categories/${categoryId}`)
  }
  // /categories-change-types obtener el select de tipo de motivo categoria

  getTypeCategory(cache = true, cacheKey = "typeCategory"): Observable<any[]> | any {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      const observable = this.http.get<any[]>(environment.base_URL + "/categories-change-types").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }
}
